/*
 *
 * ViewBuilder constants
 *
 */
export var LOAD_FILES_REQUEST = 'app/ViewBuilder/LOAD_FILES_REQUEST';
export var LOAD_FILES_SUCCESS = 'app/ViewBuilder/LOAD_FILES_SUCCESS';
export var LOAD_FILES_FAILURE = 'app/ViewBuilder/LOAD_FILES_FAILURE';
